<template>
  <div id="singleday">
    <Printer :title="agenda.AgendaName">
      <template v-slot:printContent>
        <div>
          <div class="row">
            <div class="startColumn pr-3 text-danger scheduleHeader">
              Start
            </div>
            <div class="titleColumn text-danger scheduleHeader">
              Title
            </div>
            <div class="presentColumn text-danger scheduleHeader">
              Presented By
            </div>
            <div class="locationColumn text-danger scheduleHeader">
              Location
            </div>
            <div class="qmColumn text-danger scheduleHeader">
              Quartermaster Info
            </div>
            <div class="currColumn text-danger scheduleHeader">
              Curr
            </div>
            <div class="audienceColumn text-danger scheduleHeader">
              Audience
            </div>
          </div>
          <div
            class="row pt-2 pb-2 border-bottom"
            v-for="a in agenda.AgendaItems"
            :key="a.Id"
          >
            <div class="startColumn pr-3 scheduleCell">
              {{ timeFormatter(a.StartTime) }}
            </div>
            <div class="titleColumn scheduleCell">
              {{ a.Topic }}
            </div>
            <div class="presentColumn scheduleCell">
              {{ getStaffName(a.PresenterScouterKey) }}
            </div>
            <div class="locationColumn scheduleCell">
              {{ a.LocationInfo }}
            </div>
            <div class="qmColumn scheduleCell">
              <div v-html="a.QuartermasterInfo" />
            </div>
            <div class="currColumn scheduleCell">
              {{ a.CurriculumReference }}
            </div>
            <div class="audienceColumn scheduleCell">
              {{ a.Audience }}
            </div>
          </div>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import Printer from '@/components/_main/printer.vue'
import formatter from '@/services/formatter.js'

export default {
  name: 'PrintCourseScheduleSingleDay',
  components: {
    Printer
  },
  props: {
    agenda: {
      type: Object,
      default: function () {
        return {}
      }
    },
    staff: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      printCellStyle: { font: '9pt Raleway', margin: '0', padding: '0' },
      printHeaderCellStyle: { font: '9pt Raleway' },
      agendaName: null,
      location: null,
      startDate: null,
      isLazy: true
    }
  },
  watch: {
    agenda: function (newValue, oldValue) {
      if (newValue === null) {
        this.agendaName = null
      } else {
        this.agendaName = newValue.AgendaName
        this.location = newValue.Location
        this.startDate = this.dateFormatter(newValue.StartDate)
      }
    }
  },
  methods: {
    timeFormatter: function (cellValue) {
      return formatter.formatAsTime(cellValue)
    },
    dateFormatter: function (params) {
      return formatter.formatAsDate(params)
    },
    getStaffName: function (scouterKey) {
      const scouter = this.staff[scouterKey]

      if (scouter === undefined) {
        return ''
      } else {
        return scouter
      }
    }
  }
}
</script>
